import React, { useEffect, useRef, useState } from "react";
import ReactCrop from "react-image-crop";
import { ArrowLeftOutlined, LeftCircleOutlined } from "@ant-design/icons";
import "react-image-crop/dist/ReactCrop.css";
import "./CategoryManagementForm.scss";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import Buttons from "../../../Components/Buttons/Buttons";
import FormInputs from "../../../Components/FormInputs/FormInputs";
import { Button, Card, Modal } from "antd";
import TextArea from "antd/es/input/TextArea";
import Loader from "../../../Components/Loader/Loader";
import { postApi, putApi } from "../../../Utlis/apiService";
import { ADD_NEW_CATEGORY, UPDATE_CATEGORY } from "../../../Utlis/apiPath";
import { errorToast, successToast } from "../../../Services/ToastHelper";
import { BackArrowIcon } from "../../../Components/Icons/BackArrowIcon";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const CategoryManagementForm = ({
  setAddCategoryForm,
  editData,
  fetchAllCategorys,
  addCategoryForm,
}) => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [croppedImages, setCroppedImages] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [editorContent, setEditorContent] = useState("");
  const fileInputRef = useRef(null);
  const [removedImageIds, setRemovedImageIds] = useState([]);
  const [errors, setErrors] = useState({});
  const cropperRef = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [crop, setCrop] = useState({
    unit: "px",
    width: 200,
    height: 200,
    x: 50,
    y: 50,
  });

  const handleImageChange = (event) => {
    if (event.target.files && event.target.files.length > 0) {
      const newImage = event.target.files[0];

      const reader = new FileReader();
      reader.onload = (event) => {
        setSelectedImage(event.target.result);
        setIsModalOpen(true);
      };
      reader.readAsDataURL(newImage);
      event.target.value = null;
    }
  };

  const handleModalCancel = () => {
    setIsModalOpen(false);
    setSelectedImage(null);
  };

  useEffect(() => {
    if (selectedImage) {
      setCrop({
        unit: "px",
        width: 300,
        height: 300,
        x: 50,
        y: 50,
      });
    }
  }, [selectedImage]);

  useEffect(() => {
    if (editData) {
      setTitle(editData.name || "");
      setDescription(editData.description || "");
      setEditorContent(editData.description || "");

      setCroppedImages(
        (editData.images || []).map((imageUrl) => ({
          type: "existing",
          url: imageUrl,
        }))
      );
    } else {
      setTitle("");
      setDescription("");
      setEditorContent("");
      setCroppedImages([]);
    }
  }, [editData]);

  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setSelectedImage(reader.result);
        fileInputRef.current.value = "";
      };
      reader.readAsDataURL(file);
    }
  };

  const getCroppedImg = (sourceImage, crop) => {
    return new Promise((resolve, reject) => {
      const image = new Image();
      image.src = sourceImage;
      image.crossOrigin = "anonymous";

      image.onload = () => {
        const canvas = document.createElement("canvas");
        const scaleX = image.width / image.naturalWidth;
        const scaleY = image.height / image.naturalHeight;

        canvas.width = crop.width;
        canvas.height = crop.height;
        const ctx = canvas.getContext("2d");

        ctx.drawImage(
          image,
          crop.x * scaleX,
          crop.y * scaleY,
          crop.width * scaleX,
          crop.height * scaleY,
          0,
          0,
          crop.width,
          crop.height
        );

        canvas.toBlob(
          (blob) => {
            if (!blob) {
              reject(new Error("Canvas is empty"));
              return;
            }
            resolve(blob);
          },
          "image/jpeg",
          1
        );
      };

      image.onerror = (err) => reject(err);
    });
  };

  const handleCropComplete = async () => {
    if (cropperRef.current) {
      const cropper = cropperRef.current.cropper;
      cropper.getCroppedCanvas().toBlob((blob) => {
        if (blob) {
          setCroppedImages((prev) => [...prev, { type: "new", blob }]);
          setSelectedImage(null);
        }
      }, "image/jpeg");
    }
  };

  const handleRemoveImage = (index) => {
    setCroppedImages((prev) => {
      const updatedImages = [...prev];
      const removedImage = updatedImages.splice(index, 1)[0];

      if (removedImage.type === "existing") {
        setRemovedImageIds((prevIds) => [...prevIds, removedImage.url.id]);
      }

      return updatedImages;
    });
  };

  const validateForm = () => {
    const newErrors = {};
    if (!title) newErrors.title = "Title is required";
    if (!editorContent) newErrors.editorContent = "Description is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = async () => {

    if (!validateForm()) return;

    if (
      croppedImages.length === 0 &&
      (!editData?.images || editData.images.length === 0)
    ) {
      errorToast("Please add at least one image before saving.");
      return;
    }
    
    setIsLoading(true);

    try {
      const formData = new FormData();
      formData.append("name", title);
      formData.append("description", editorContent);

      const isUpdate = Boolean(editData?.id);

      if (isUpdate) {
        formData.append("id", editData.id);
        const previousImageIds = [...new Set(removedImageIds)].join(",");
        if (previousImageIds) {
          formData.append("previousImageIds", previousImageIds);
        }
      }

      croppedImages.forEach((image, index) => {
        if (image.type === "new") {
          formData.append(`images`, image.blob, `image_${index}.jpeg`);
        }
      });

      const apiUrl = isUpdate ? UPDATE_CATEGORY : ADD_NEW_CATEGORY;
      const response = await (isUpdate
        ? putApi(apiUrl, formData, {
            headers: { "Content-Type": "multipart/form-data" },
          })
        : postApi(apiUrl, formData, {
            headers: { "Content-Type": "multipart/form-data" },
          }));

      // Check for different success status codes
      if (response && (response.status === 200 || response.status === 201 || response.status === 'success')) {
        successToast(response.message || "Category saved successfully!");
        setAddCategoryForm(false);
        
        // Safely call fetchAllCategorys if it exists
        if (typeof fetchAllCategorys === 'function') {
          await fetchAllCategorys();
        }
      } else {
        // Handle API error response
        const errorMessage = response?.message || response?.error || "Failed to save category";
        errorToast(errorMessage);
      }
    } catch (error) {
      console.error("Error saving category:", error);
      
      // More specific error handling
      if (error.response) {
        // API returned an error response
        const errorMessage = error.response.data?.message || 
                           error.response.data?.error || 
                           `Server error: ${error.response.status}`;
        errorToast(errorMessage);
      } else if (error.request) {
        // Network error
        errorToast("Network error. Please check your connection and try again.");
      } else {
        // Other errors
        errorToast("An unexpected error occurred while saving the category.");
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = () => {
    handleCropComplete();
    setIsModalOpen(false);
  };

  return (
    <div className="addcls">
      {isLoading && <Loader />}
      <div className={addCategoryForm ? "addcls_modal" : "addcls_cont"}>
                 <div className="addcls_cont_header">
           <h2>
             <div
               style={{ cursor: "pointer" }}
               onClick={() => setAddCategoryForm(false)}
             >
               <BackArrowIcon />
             </div>

             {editData ? "Edit Category" : "Add Category"}
           </h2>
         </div>

        <Card style={{ marginBottom: "10px" }} className="addcls_cont_form">
          <div className="form-group">
            <FormInputs
              title="Category Title"
              type="text"
              placeholder="Enter category title"
              className="title-input"
              value={title}
              onChange={(e) => {
                setTitle(e.target.value);
                if (errors.title) {
                  setErrors((prev) => ({ ...prev, title: "" }));
                }
              }}
            />
            {errors.title && <span className="error-text">{errors.title}</span>}
          </div>
                     <div className="form-group">
             <label htmlFor="description">Category Description*</label>
             <ReactQuill
               theme="snow"
               value={editorContent}
               onChange={(value) => {
                 setEditorContent(value);
                 setErrors((prevErrors) => ({
                   ...prevErrors,
                   editorContent: value.trim() ? "" : prevErrors.editorContent,
                 }));
               }}
               placeholder="Write your category description here..."
               style={{ height: "200px" }}
             />
             {errors.editorContent && (
               <p className="error">{errors.editorContent}</p>
             )}
           </div>
          <div className="form-group">
            <label style={{marginTop: "50px"}}>Media</label>
            <div className="media-section">
              <div className="media-preview">
                {croppedImages.map((image, index) => (
                  <div key={index} className="image-preview-cont">
                    <div className="uploaded-image">
                      {image.type === "existing" ? (
                        <img src={image?.url?.url} alt="Preview" />
                      ) : (
                        <img
                          src={URL.createObjectURL(image.blob)}
                          alt="Preview"
                        />
                      )}
                    </div>
                    <button
                      className="remove-image"
                      onClick={() => handleRemoveImage(index)}
                      aria-label="Remove Image"
                    >
                      X
                    </button>
                  </div>
                ))}
              </div>
              <div className="media-upload">
                {croppedImages.length < 3 && (
                  <>
                    <input
                      ref={fileInputRef}
                      type="file"
                      accept="image/*"
                      onChange={handleFileSelect}
                      style={{ display: "none" }}
                    />
                    <button
                      className="upload-button"
                      onClick={() => fileInputRef.current?.click()}
                    >
                      +
                    </button>
                  </>
                )}
              </div>
            </div>
          </div>
          <Modal
            title="Crop Image"
            open={isModalOpen}
            onCancel={handleModalCancel}
            maskClosable={false}
            width={700}
            footer={[
              <Button key="back" onClick={handleModalCancel}>
                Cancel
              </Button>,
              <Button key="submit" type="primary" onClick={handleSubmit}>
                Submit
              </Button>,
            ]}
          >
            {selectedImage && (
              <Cropper
                src={selectedImage}
                style={{ height: 400, width: "100%" }}
                initialAspectRatio={1}
                aspectRatio={1.5}
                guides={true}
                ref={cropperRef}
                viewMode={1}
                dragMode="move"
                scalable={true}
                cropBoxResizable={true}
                cropBoxMovable={true}
              />
            )}
          </Modal>
          <input
            ref={fileInputRef}
            accept=".jpeg, .jpg, .png, .webp"
            type="file"
            onChange={handleImageChange}
            style={{ display: "none" }}
                     />
         </Card>
         <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "20px" }}>
           <Buttons variant="primary" onClick={handleSave}>
             {editData ? "Update" : "Save"}
           </Buttons>
         </div>
       </div>
     </div>
   );
 };

export default CategoryManagementForm;
